import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';

import { DocumentTransporterConfiguration } from '../models/document-transporter.configuration';

@Injectable({ providedIn: 'root' })
export class DocumentTransporterConfigurationService implements ITransportConfigurationService<DocumentTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<DocumentTransporterConfiguration>> {
    return this.apiProvider.publicGet<DocumentTransporterConfiguration>(this.publicResourceUrl('document', transporterId), { observe: 'response' });
  }

  retrieveConfigurationFromCurrentTransporter(): Observable<HttpResponse<DocumentTransporterConfiguration>> {
    return this.apiProvider.publicGet<DocumentTransporterConfiguration>(this.publicResourceUrl('document'), { observe: 'response' });
  }

  updateConfiguration(configuration: DocumentTransporterConfiguration, transporterId?: number): Observable<HttpResponse<DocumentTransporterConfiguration>> {
    return this.apiProvider.configurationPut<DocumentTransporterConfiguration>(this.moderatorResourceUrl('document', transporterId), configuration);
  }
}
